import { Value, Block, List, Null } from './ast'
import { Drawing } from '../api/drawing'

class Stack {
    items: Value[] = []

    pushDrawing(value: Drawing): void {
        this.items.push({
            type: "drawing",
            value: value
        })
    }

    pushNumber(value: number): void {
        this.items.push({
            type: "number",
            value: value
        })
    }

    pushSymbol(name: string): void {
        this.items.push({
            type: "symbol",
            name: name
        })
    }

    pushLiteral(value: Value): void {
        this.items.push(value)
    }

    popNumber(): number {
        const value = this.pop();
        if (value.type == "number")
            return value.value;
        else
            this.expected("number", value)
    }

    popNumberOrSymbol(): number | string {
        const value = this.pop();
        if (value.type == "number")
            return value.value;

        if (value.type == "symbol")
            return value.name;

        this.expected("number or symbol", value)
    }


    popListOrNull(): List | Null {
        const value = this.pop();
        if (value.type == "list" || value.type == "null")
            return value;

        this.expected("list or null", value)
    }

    popDrawing(): Drawing {
        const value = this.pop();
        if (value.type == "drawing")
            return value.value;
        else
            this.expected("drawing", value)
    }

    popSymbol(): string {
        const value = this.pop();
        if (value.type == "symbol")
            return value.name;
        else
            this.expected("symbol", value)
    }

    popBlock(): Block {
        const value = this.pop();
        if (value.type == "block")
            return value;
        else
            this.expected("block", value)
    }

    pop(): Value {
        const value = this.peek();
        if (value) {
            this.items.pop();
            if (value.type == "label")
                return value.value;
            else
                return value;
        }

        throw new Error("stack underflow")
    }

    peek(): Value {
        if (this.items.length > 0)
            return this.items[this.items.length - 1];
    }

    expected(type: string, value: Value): void {
        throw new Error("expected " + type + " and got " + value.type)
    }
}

export { Stack }